import { useEffect, useState } from "react";
import { RealtimeData, ShopTheme } from "./types/types";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translations.json";
import translationRO from "./locales/ro/translations.json";
import { openVariant } from "./components/ProductCard";

const isProduction = process.env.NODE_ENV === "production";

const resources: Record<string, { translation: Record<string, string> }> = {
  en: {
    translation: translationEN,
  },
  ro: {
    translation: translationRO,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "ro", // default RO
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export const ReplacementsWidget = ({ permanentDomain, sku, country }: { permanentDomain: string; sku: string; country: string }) => {
  const [theme, setTheme] = useState<ShopTheme>();
  const [replacements, setReplacements] = useState<RealtimeData[]>([]);
  const { t } = useTranslation();

  // Update language when countryCode is available
  useEffect(() => {
    if (country) {
      const language = country.toLowerCase();

      if (resources[language]) {
        i18n.changeLanguage(language);
      } else {
        // Fallback to default language if country code is not supported
        i18n.changeLanguage(i18n.options.fallbackLng as string);
      }
    } else {
      // Fallback to default language if country code is not supported
      i18n.changeLanguage(i18n.options.fallbackLng as string);
    }
  }, [country]);

  const API_URL =
    isProduction || true
      ? `https://partsfinder.clpstudio.ro/api/replacements?permanentDomain=${permanentDomain}&sku=${encodeURIComponent(sku)}&country=${country}`
      : `http://localhost:50483/api/replacements?permanentDomain=${permanentDomain}&sku=${encodeURIComponent(sku)}&country=${country}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(API_URL);
        const res = await response.json();

        const theme = res?.theme;
        setTheme(theme);

        const replacements: RealtimeData[] = res?.replacementsData?.replacements || [];

        setReplacements(replacements);
      } catch (e) {
        console.log(e);
      }
    };

    fetchData();
  }, []);

  if (!theme || replacements.length === 0) {
    return null;
  }

  return (
    <div>
      {replacements.length > 0 && (
        <div className="flex flex-col w-full h-full">
          {replacements.map((replacement) => {
            return (
              <div key={replacement.sku} className="space-x-4 p-4 border rounded-lg">
                <h2 className="lg:text-base text-sm font-semibold text-gray-900">
                  {t("product_replaced_by")}{" "}
                  <button className="text-blue-600 hover:text-blue-800 underline font-semibold" onClick={() => openVariant(replacement)}>
                    {replacement.sku}
                  </button>
                </h2>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
